var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMascusIcon = function SvgMascusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 151,
    viewBox: "0 0 212 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.099 111.355c5.095 0 9.276-4.181 9.276-9.277 0-5.095-4.18-9.276-9.276-9.276s-9.277 4.18-9.277 9.276 4.05 9.277 9.277 9.277ZM130.651 111.355c5.096 0 9.277-4.181 9.277-9.277 0-5.095-4.181-9.276-9.277-9.276-5.095 0-9.276 4.18-9.276 9.276s4.181 9.277 9.276 9.277ZM43.375 74.118v26c0 2.091-1.699 3.659-3.658 3.659H9.927",
    stroke: "#2C112D",
    strokeWidth: 1.975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.822 18.46v66.895h22.342l7.447 18.552h29.658l7.317-18.552h22.342l-1.96-7.578s-14.764-7.317-29.658-7.317H87.928M50.822 74.118h-7.447",
    stroke: "#2C112D",
    strokeWidth: 1.975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m65.586 85.355 3.266-26.523c.262-1.83 1.83-3.266 3.659-3.266h11.628c2.09 0 3.658 1.698 3.658 3.658v26M91.586 85.355h-26M91.586 85.355v18.552",
    stroke: "#2C112D",
    strokeWidth: 1.975,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m129.585 29.572-1.782-.889a41.99 41.99 0 0 0 .331 38.13l.002.004 1.767-.92a39.798 39.798 0 0 1-4.507-19.136 39.825 39.825 0 0 1 4.189-17.19ZM205.383 48.203a39.803 39.803 0 0 1-4.505 17.694l1.767.92.002-.004a41.999 41.999 0 0 0 .331-38.13l-1.782.889a39.818 39.818 0 0 1 4.187 18.631ZM183.864 11.936l.92-1.767-.004-.002a42 42 0 0 0-38.13-.33l.889 1.781a39.834 39.834 0 0 1 17.852-4.195c6.664 0 12.947 1.63 18.473 4.513ZM183.243 83.228a39.835 39.835 0 0 1-17.852 4.195 39.83 39.83 0 0 1-18.474-4.512l-.919 1.767.003.002a41.996 41.996 0 0 0 38.13.33l-.888-1.782Z",
    fill: "#2C112D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 118.41,
    y: 31.523,
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(-20 118.41 31.523)",
    fill: "#2C112D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 131.912,
    y: 39.379,
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(-110 131.912 39.379)",
    fill: "#2C112D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 182.838,
    y: 0.78,
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(72.288 182.838 .78)",
    fill: "#2C112D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 174.449,
    y: 13.957,
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(-17.712 174.449 13.957)",
    fill: "#2C112D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 64.865,
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(162.846 212 64.865)",
    fill: "#2C112D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 198.906,
    y: 56.349,
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(72.846 198.906 56.349)",
    fill: "#2C112D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 148.923,
    y: 94.082,
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(-112 148.923 94.082)",
    fill: "#2C112D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 156.303,
    y: 80.315,
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(158 156.303 80.315)",
    fill: "#2C112D"
  })));
};
export default SvgMascusIcon;